export const GoogleMapApiConfig = 'AIzaSyAJR7bI2rD0YJ-kdXFtmtQhyJk5DB9Dvbw';